export class Trophie {
    id: number;
    country: string;
    count: number;
    playerId: number;
    leagueName: string;
    teamname: string;
    as_coach: boolean;
    seasons: string;
    ranking: string;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/trophie.model.ts